import React from 'react';

export const OptionButton = ({ label, count, isActive, onClick }) => {
  return (
    <button className={`option-button ${isActive ? "active-button" : ""}`} onClick={onClick}>
      {label}
      <span className="count-capsule">{count}</span>
    </button>
  );
};
